import React from 'react';
import swal from 'sweetalert';
import { sendRequest } from '../hooks/fetchData';
import { useMenuContext } from '../store/order_context';

export default function OrderMenuTimeOut({ }) {
  const { userOrder,totalDailyPrice,orderTimeSettings} = useMenuContext();
  return (
    <section className="main_content">
      <input id="Order_ComplaintID" name="Order.ComplaintID" type="hidden" value="0" />
      <div className="container">
        <h1 className="page-title">
          <text>محتويات العربة</text>
        </h1>

        <div className="alert danger" role="alert">عفواً تم انتهاء الوقت المحدد للطلبات.</div>

        {(userOrder &&  new Date(userOrder?.orderDate)?.toDateString() === new Date().toDateString())&&(
        <form className="form-horizontal">
          <div className="food_list">
            <div className="center">

              <h2>
                رقم الطلب
                <bdo dir="ltr">{userOrder?.orderNumber}</bdo>
              </h2>
            </div>

            <table className="table table-bordered table-curved">
              <thead className="thead-default">
                <tr>
                  <th>الصنف</th>
                  <th>المطعم</th>
                  <th>العدد</th>
                  <th>السعر</th>
                </tr>
              </thead>

              <tfoot>
                <tr className="total">
                  <td colSpan={3}>الإجمالي</td>
                  <td colSpan={2}>
                    <bdo dir="ltr">{totalDailyPrice}</bdo>
                  </td>
                </tr>
              </tfoot>

            <tbody>
{userOrder?.orderDetails.map((order, idx) => (
  order.mealsDetails.map((meal, mIdx) => (
    <tr className="confirmed" key={`${idx}-${mIdx}`}>
      <td>{meal.name}</td>
      <td>{order.resturantName}</td>
      <td>
        <bdo dir="ltr">{meal.count}</bdo>
      </td>
      <td>
        <bdo dir="ltr">{meal.count * meal.price}</bdo>
      </td>
    </tr>
  ))
))}

</tbody>

            </table>
          </div>
        </form>
      )}
      </div>
    </section>
   );
 }
